/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import React from "react"
import ReactDOM from "react-dom"

import thunkMiddleware from "redux-thunk"
import { Provider } from "react-redux"
import { createStore, applyMiddleware } from "redux"
import { composeWithDevTools } from "redux-devtools-extension"
import soccerApp from "./reducers"
import * as stat from "./util/analytics"

import { App } from "./App"
import { statInit } from "./util/analytics"
import { trackEvent } from "trux"

import "trux/dist/reset.css"
import "trux/dist/trux.css"
import "./styles/ron.css"

let store = createStore(
    soccerApp,
    composeWithDevTools(applyMiddleware(thunkMiddleware))
)

// Unregister service worker
if ("serviceWorker" in navigator) {
    // navigator.serviceWorker
    //     .getRegistrations()
    //     .then(function (registrations) {
    //         for (let registration of registrations) {
    //             registration.unregister()
    //         }
    //     })
    //     .catch(function (err) {
    //         console.log("Service Worker unregistration failed: ", err)
    //     })
    // navigator.serviceWorker
    //     .register("./service-worker.js")
    //     .then(function (registration) {
    //         console.log("Registration succeeded.")
    //         registration.unregister().then(function (boolean) {
    //             // if boolean = true, unregister is successful
    //             console.log("unregistered service worker")
    //         })
    //     })
    //     .catch(function (error) {
    //         // registration failed
    //         console.log("Registration failed with " + error)
    //     })
}

//Needed for submitting events to google analytics
//Do not remove without refactor
statInit(store)

function onWindowSizeChange() {
    var tm = "noteam"
    var gm = "nogame"
    var parts = window.location.href.split("/")
    var key = ""
    for (var i = 0; i < parts.length; i++) {
        var p = parts[i]
        if (key === "#") {
            tm = p
            key = ""
        } else if (key === "games") {
            gm = p
            key = ""
        } else {
            key = p
        }
    }
    if (window.innerHeight > window.innerWidth) {
        trackEvent({ context: "Window", action: "Portrait" })
    } else {
        trackEvent({ context: "Window", action: "Landscape" })
    }
    store.dispatch({
        type: "WINDOW_SIZE",
        height: window.innerHeight,
        width: window.innerWidth - 1,
    })
    setTimeout(() => {
        store.dispatch({
            type: "WINDOW_SIZE",
            height: window.innerHeight,
            width: window.innerWidth,
        })
    }, 200)
}
window.onresize = onWindowSizeChange

if (window.location.hash.includes("back=1")) {
    window.back_ref = document.referrer
}

ReactDOM.render(
    <Provider store={store}>
        <App store={store} />
    </Provider>,
    document.getElementById("root")
)
